<p-table [value]="model" styleClass="p-datatable-striped" [autoLayout]="true">
    <ng-template pTemplate="header">
        <tr>
            <th>Name</th>
            <th>Level</th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-entry>
        <tr>
            <td>
                <div>{{entry.name}}</div>
                <button *ngIf="entry.canEditUsers" pButton class="edit-button p-button p-button-link"
                        icon="pi pi-pencil" label="Edit Users" (click)="showDialog(entry)"></button>
            </td>
            <td class="text-right">{{entry.level}}</td>
            <td>

                <div *ngIf="!entry.completed">
                    <div *ngIf="entry.hasLowerLevelPending">
                        <label>Prior signoffs must be completed first.</label>
                    </div>
                    <div *ngIf="entry.requireOnShift">
                        <label>This signoff must be completed while on shift.</label>
                    </div>
                    <div *ngIf="entry.canSignoff && !entry.hasLowerLevelPending">
                        <button pButton class="p-button p-button-primary" (click)="doSignOff(entry, 'signoff', $event)">Sign Off</button>
                        <button pButton *ngIf="entry.allowsReject" class="p-button p-button-danger reject-button" (click)="doSignOff(entry, 'reject', $event)">Reject</button>
                    </div>
                    <p-confirmPopup [key]="entry.segment.id.toString()"></p-confirmPopup>
                </div>

                <div>
                    <div *ngFor="let signoff of entry.signoffs">
                        {{signoff.signoff ? 'Signed off' : 'Rejected'}} by {{signoff.user.firstName}} {{signoff.user.lastName}}
                        at {{signoff.signoffTime | date: 'MM/dd/yyyy HH:mm'}}
                        <button *ngIf="signoff.canUndo"
                                title="Undo {{signoff.signoff ? 'Signoff' : 'Rejection'}}"
                                pButton class="undo-button p-button-outlined" icon="fa fa-undo"
                                (click)="undoSignoff(entry, signoff, $event)">
                        </button>
                        <p-confirmPopup [key]="signoff.id.toString()"></p-confirmPopup>
                    </div>
                </div>
                <div>
                    {{entry.displayMessage}}
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog [header]="dialogHeader" [(visible)]="dialogVisible" [modal]="true" [draggable]="false" [resizable]="false"
          [breakpoints]="$any({ '1000px': '80vw', '640px': '100vw' })"
          [style]="{ width: '70vw', top: '5vh', position: 'fixed' }">
    <p-table [value]="dialogUsers" [autoLayout]="true">
        <ng-template pTemplate="header">
            <tr>
                <th>Can Signoff</th>
                <th>First Name</th>
                <th>Last Name</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-entry>
            <tr class="edit-users-table-row">
                <td>
                    <p-inputSwitch [(ngModel)]="entry.selected" [disabled]="entry.disabled"
                                   [tooltipDisabled]="!entry.disabled"
                                   pTooltip="{{entry.user.user.firstName}} {{entry.user.user.lastName}} has already submitted a signoff and cannot be removed.">
                    </p-inputSwitch>
                </td>
                <td>{{entry.user.user.firstName}}</td>
                <td>{{entry.user.user.lastName}}</td>
            </tr>
        </ng-template>
    </p-table>

    <ng-template pTemplate="footer">
        <div class="p-text-right">
            <button pButton class="p-button-secondary" label="Cancel" (click)="dialogVisible = false"></button>
            <button pButton label="Save" icon="pi pi-check" (click)="updateEditUsers()"></button>
        </div>
    </ng-template>
</p-dialog>